import React from 'react';

import {CompetitionsSliderWidgetProps} from "../models/competitions-slider-widget.props";
import {CompetitionsSliderWidgetController} from "../competitions-slider-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {CompetitionsSliderWidgetLeftBar} from "./competitions-slider-widget.left-bar";
import {CompetitionsSliderWidgetRightBar} from "./competitions-slider-widget.right-bar";
import {CompetitionsSliderWidgetTopBar} from "./competitions-slider-widget.top-bar";
import {Slider} from "../../../core/components/slider/components/slider";
import {SliderGameCard} from "../../../core/components/slider/components/slider-game-card/slider.game-card";
import {ACTION_TYPES, WIDGET_TYPES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {GamesSliderWidgetGameViewModel} from "../../games-slider-widget/models/games-slider-widget.game-view-model";
import {SLIDER} from "../../../core/components/slider/slider.consts";

export class CompetitionsSliderWidgetComponentProps extends CompetitionsSliderWidgetProps {
  showOdds: Boolean;
}

export const CompetitionsSliderWidgetComponent = (({controller, showOdds}: CompetitionsSliderWidgetComponentProps) => {
  const {state, device, navigationManager} = controller;
  const {containerClassName, selectedCompetitionId, dataSource, appSettings, appState, sponsorshipBookmaker, hasOdds} = state;
  const {screenWidth, isSmallView} = device;

  const containerProps = {
    className: [
      containerClassName,
      'competitions-slider-widget-container',
    ].join(' ')
  }

  const onSliderContentSlideEvent = (direction: String) => controller.action(ACTION_TYPES.sliderSlide, {
    direction: direction,
    competitionId: selectedCompetitionId,
    sportTypeId: dataSource.games[0].competition.sport.id,
    widgetType: WIDGET_TYPES.slider,
    partner: appSettings.bootstrapSettings.publisherId,
    screenResolution: screenWidth
  });

  const onMatchClickEvent = (game: GamesSliderWidgetGameViewModel) => {
    if (appState.settings.bootstrapSettings.eventClick) {
      appState.settings.bootstrapSettings.eventClick(game.linkModel);
    } else if (appSettings.publisherSettings?.bookmakerUrl) {
      navigationManager.gotoUrl(appSettings.publisherSettings?.bookmakerUrl, false, true);
    } else if (appState.hasSponsorship) {
      navigationManager.gotoUrl(sponsorshipBookmaker.link, false, true);
    }

    controller.action(ACTION_TYPES.matchDetailsClick, {
      gameId: game.id,
      status: game.domainModel.statusGroup,
      source: APP.ANALYTICS.SOURCES.slider,
      competitionId: game.competition.id,
      sportTypeId: game.sport.id,
      widgetType: WIDGET_TYPES.slider,
      screenResolution: screenWidth
    });

    return false;
  }

  const widgetProps = {
    showFirstTriangle: state.isLeftBarVisible,
    showLastTriangle: state.isRightBarVisible,
    isRtl: controller.device.isRtl,
    height: controller.state.hasOdds ? (controller.device.isSmallView ? SLIDER.CONTAINER_HEIGHT.mobileLarge : SLIDER.CONTAINER_HEIGHT.large) : SLIDER.CONTAINER_HEIGHT.small,
    id: controller.state.selectedCompetitionId,
    onArrowClick: onSliderContentSlideEvent,
    initialIndex: controller.state.initialIndex,
    isLargeView: controller.device.isLargeView,
    hasOdds,
    emptyStateText: controller.state.emptyStateText,
    publisherOnGameClick: null,
    isHandset: controller.state.userAgent.isHandset,
    theme: SLIDER.THEMES.diagonal,
    items: controller.state.games,
    CardComponent: SliderGameCard,
    forceArrows: true,
    cardComponentProps: {
      showOdds,
      controller,
      isSmallView,
      onMatchClickEvent,
      use365Prefix: controller.state.settings.use365Prefix,
      blockInnerLinks: controller.state.settings.blockInnerLinks,
      widgetName: APP.GOOGLE_ANALYTICS.SOURCES.slider,
      source: APP.ANALYTICS.SOURCES.slider
    }
  }

  return (
    <div {...containerProps}>
      {
        controller.state.isTopBarVisible && <CompetitionsSliderWidgetTopBar controller={controller} />
      }
      <div className={'competitions-slider-widget-containers'}>
        {
          controller.state.isLeftBarVisible && <CompetitionsSliderWidgetLeftBar controller={controller} showOdds={showOdds}/>
        }
        <Slider {...widgetProps}/>
        {
          controller.state.isRightBarVisible && <CompetitionsSliderWidgetRightBar controller={controller} />
        }
      </div>
    </div>
  )
});

const settings: ComposeSettings = {
  component: CompetitionsSliderWidgetComponent,
  propsType: CompetitionsSliderWidgetComponentProps,
  controllerType: CompetitionsSliderWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,


  observe: true,
}

export const CompetitionsSliderWidget = Compose(settings);
